import { setupFinePartita } from "./finePartita.js";

export default function vittoria(k) {
    k.scene("vittoria", () => {
        setupFinePartita(k, "Congratulazioni, hai vinto!");
    });
}
